@if (panel; as panelApi) {
  @if (!isPresentationActive(panelApi)) {
    <div
      class="map-title-panel"
      [class.is-find-open]="panelApi.findOpen()"
      role="group"
      [attr.aria-label]="i18n.t().mapTitlePanelAria"
    >
      <div class="map-title-header">
        <div
          class="map-title-shell d-flex align-items-center border shadow-1 bg-body overflow-hidden"
          [class.is-find-open]="panelApi.findOpen()"
        >
          @if (showBackButton) {
            <button
              class="map-title-back-button btn btn-icon btn-sm border-0 bg-transparent"
              data-testid="mindmap-editor-back"
              type="button"
              [attr.aria-label]="i18n.t().goBack"
              [title]="i18n.t().goBack"
              (click)="onGoBackClick()"
            >
              <span class="map-title-icon" aria-hidden="true">
                <svg
                  class="sa-icon sa-nofill"
                  viewBox="0 0 24 24"
                  focusable="false"
                  aria-hidden="true"
                >
                  <use href="/assets/icons/sprite.svg#arrow-left"></use>
                </svg>
              </span>
            </button>
            <span
              class="map-title-divider border-start"
              aria-hidden="true"
            ></span>
          }

          @if (!publicViewer) {
            <button
              class="map-title-icon-button btn btn-icon btn-sm border-0 bg-transparent"
              data-testid="mindmap-editor-menu-toggle"
              type="button"
              [attr.aria-label]="i18n.t().mapOptionsAria"
              aria-haspopup="menu"
              [attr.aria-expanded]="panelApi.mapMenuOpen()"
              (click)="onMapOptionsButtonClick()"
            >
              <span class="map-title-icon" aria-hidden="true">
                <svg
                  class="sa-icon sa-nofill"
                  viewBox="0 0 24 24"
                  focusable="false"
                  aria-hidden="true"
                >
                  <use href="/assets/icons/sprite.svg#menu"></use>
                </svg>
              </span>
              <span class="map-title-icon-chevron" aria-hidden="true">
                <svg
                  class="sa-icon sa-nofill"
                  viewBox="0 0 24 24"
                  focusable="false"
                  aria-hidden="true"
                >
                  <use href="/assets/icons/sprite.svg#chevron-down"></use>
                </svg>
              </span>
            </button>

            @if (canUpdateMindMap) {
              <button
                class="map-title-appearance-button btn btn-icon btn-sm border-0 bg-transparent"
                data-testid="mindmap-editor-appearance"
                type="button"
                [attr.aria-label]="i18n.t().appearance"
                [title]="i18n.t().appearance"
                (click)="onMenuItemClick('appearance')"
              >
                <img
                  class="map-title-appearance-icon"
                  src="/assets/icons/appearance.svg"
                  alt=""
                  aria-hidden="true"
                />
              </button>
            }

            <app-theme-toggle
              buttonClass="map-title-theme-toggle btn btn-icon btn-sm border-0 bg-transparent"
              iconClass="sa-icon sa-nofill map-title-theme-toggle-icon"
            />

            <span
              class="map-title-divider border-start"
              aria-hidden="true"
            ></span>
          }

          @if (panelApi.findOpen()) {
            <div
              class="map-title-find-row d-flex align-items-center flex-grow-1"
            >
              <div class="map-title-find st-wrapper flex-grow-1">
                <div class="st-search-wrapper">
                  <div
                    class="input-group input-group-sm flex-nowrap"
                    role="search"
                  >
                    <span
                      class="find-search-icon input-group-text border-0"
                      aria-hidden="true"
                    >
                      <svg
                        class="sa-icon sa-nofill"
                        viewBox="0 0 24 24"
                        focusable="false"
                        aria-hidden="true"
                      >
                        <use href="/assets/icons/sprite.svg#search"></use>
                      </svg>
                    </span>
                    <input
                      #findInput
                      data-testid="mindmap-find-input"
                      class="find-input form-control border-0"
                      type="text"
                      [value]="panelApi.findQuery()"
                      [placeholder]="i18n.t().findPlaceholder"
                      (input)="panelApi.onFindQueryInput($event)"
                    />
                    <span
                      class="find-shortcut input-group-text border-0 bg-transparent small text-muted"
                      >{{ i18n.t().searchShortcut }}</span
                    >
                    <button
                      class="find-close btn btn-system btn-sm"
                      data-testid="mindmap-find-close"
                      type="button"
                      [attr.aria-label]="i18n.t().closeFindPanel"
                      (click)="panelApi.onFindClose()"
                    >
                      <svg class="sa-icon" focusable="false" aria-hidden="true">
                        <use href="/assets/icons/sprite.svg#x"></use>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          } @else {
            <button
              class="map-title-search btn btn-icon border-0 bg-transparent"
              data-testid="mindmap-find-open"
              type="button"
              [attr.aria-label]="i18n.t().findInMindmap"
              (click)="onSearchButtonClick()"
            >
              <svg
                class="sa-icon sa-nofill"
                viewBox="0 0 24 24"
                focusable="false"
                aria-hidden="true"
              >
                <use href="/assets/icons/sprite.svg#search"></use>
              </svg>
            </button>
          }
        </div>

        @if (!publicViewer && panelApi.mapMenuOpen()) {
          <div
            class="map-title-menu dropdown-menu show shadow-3"
            role="menu"
            [attr.aria-label]="i18n.t().mapMenuAria"
          >
            @if (canUpdateMindMap) {
              <button
                class="map-title-menu-item versions-menu-item dropdown-item d-flex align-items-center gap-2"
                data-testid="mindmap-editor-action-versions"
                type="button"
                role="menuitem"
                (click)="onMenuItemClick('versions')"
              >
                <span class="map-title-menu-icon" aria-hidden="true">
                  <svg
                    class="sa-icon sa-nofill"
                    viewBox="0 0 24 24"
                    focusable="false"
                    aria-hidden="true"
                  >
                    <use href="/assets/icons/sprite.svg#refresh-ccw"></use>
                  </svg>
                </span>
                <span class="map-title-menu-label">{{
                  i18n.t().versions
                }}</span>
                <span class="map-title-menu-chevron" aria-hidden="true">
                  <svg
                    class="sa-icon sa-nofill"
                    viewBox="0 0 24 24"
                    focusable="false"
                    aria-hidden="true"
                  >
                    <use href="/assets/icons/sprite.svg#chevron-right"></use>
                  </svg>
                </span>
              </button>
            }
            @if (canUpdateMindMap) {
              <button
                class="map-title-menu-item dropdown-item d-flex align-items-center gap-2"
                data-testid="mindmap-editor-action-tags"
                type="button"
                role="menuitem"
                (click)="onTagsMenuClick()"
              >
                <span class="map-title-menu-icon" aria-hidden="true">
                  <svg class="sa-icon sa-nofill">
                    <use href="/assets/icons/sprite.svg#tag"></use>
                  </svg>
                </span>
                <span class="map-title-menu-label">{{
                  i18n.t().tagsTitle
                }}</span>
              </button>
            }
            @if (canCreateMindMap) {
              <button
                class="map-title-menu-item dropdown-item d-flex align-items-center gap-2"
                data-testid="mindmap-editor-action-duplicate"
                type="button"
                role="menuitem"
                (click)="onMenuItemClick('duplicate')"
              >
                <span class="map-title-menu-icon" aria-hidden="true">
                  <svg
                    class="sa-icon sa-nofill"
                    viewBox="0 0 24 24"
                    focusable="false"
                    aria-hidden="true"
                  >
                    <use href="/assets/icons/sprite.svg#copy"></use>
                  </svg>
                </span>
                <span class="map-title-menu-label">{{
                  i18n.t().duplicate
                }}</span>
              </button>
            }
            @if (canUpdateMindMap) {
              <button
                class="map-title-menu-item dropdown-item d-flex align-items-center gap-2"
                data-testid="mindmap-editor-action-share"
                [class.is-limit-disabled]="mindMapShareBlocked"
                type="button"
                role="menuitem"
                [attr.aria-disabled]="mindMapShareBlocked ? 'true' : null"
                (click)="onMenuItemClick('share')"
              >
                <span class="map-title-menu-icon" aria-hidden="true">
                  <svg
                    class="sa-icon sa-nofill"
                    viewBox="0 0 24 24"
                    focusable="false"
                    aria-hidden="true"
                  >
                    <use href="/assets/icons/sprite.svg#share-2"></use>
                  </svg>
                </span>
                <span class="map-title-menu-label">{{ i18n.t().share }}</span>
              </button>
            }
            @if (canUpdateMindMap) {
              <button
                class="map-title-menu-item dropdown-item d-flex align-items-center gap-2"
                data-testid="mindmap-editor-action-invite"
                [class.is-limit-disabled]="mindMapInviteBlocked"
                type="button"
                role="menuitem"
                [attr.aria-disabled]="mindMapInviteBlocked ? 'true' : null"
                (click)="onMenuItemClick('invite')"
              >
                <span class="map-title-menu-icon" aria-hidden="true">
                  <svg
                    class="sa-icon sa-nofill"
                    viewBox="0 0 24 24"
                    focusable="false"
                    aria-hidden="true"
                  >
                    <use href="/assets/icons/sprite.svg#user-plus"></use>
                  </svg>
                </span>
                <span class="map-title-menu-label">{{ i18n.t().invite }}</span>
              </button>
            }
            <button
              class="map-title-menu-item dropdown-item d-flex align-items-center gap-2"
              type="button"
              role="menuitem"
              data-testid="mindmap-editor-action-decks"
              (click)="onMenuItemClick('decks')"
            >
              <span class="map-title-menu-icon" aria-hidden="true">
                <svg
                  class="sa-icon sa-nofill"
                  viewBox="0 0 24 24"
                  focusable="false"
                  aria-hidden="true"
                >
                  <use href="/assets/icons/sprite.svg#book-open"></use>
                </svg>
              </span>
              <span class="map-title-menu-label">{{ i18n.t().decks }}</span>
            </button>
            <button
              class="map-title-menu-item dropdown-item d-flex align-items-center gap-2"
              type="button"
              role="menuitem"
              data-testid="mindmap-editor-action-present"
              (click)="onMenuItemClick('present')"
            >
              <span class="map-title-menu-icon" aria-hidden="true">
                <svg
                  class="sa-icon sa-nofill"
                  viewBox="0 0 24 24"
                  focusable="false"
                  aria-hidden="true"
                >
                  <use href="/assets/icons/sprite.svg#play-circle"></use>
                </svg>
              </span>
              <span class="map-title-menu-label">{{ i18n.t().present }}</span>
            </button>
            @if (canUpdateMindMap) {
              <button
                class="map-title-menu-item dropdown-item d-flex align-items-center gap-2"
                data-testid="mindmap-editor-action-drawing"
                type="button"
                role="menuitemcheckbox"
                [attr.aria-checked]="drawingToolsVisible"
                (click)="onDrawingToolsMenuItemClick($event)"
              >
                <span class="map-title-menu-icon" aria-hidden="true">
                  <svg
                    class="sa-icon sa-nofill"
                    viewBox="0 0 24 24"
                    focusable="false"
                    aria-hidden="true"
                  >
                    <use href="/assets/icons/sprite.svg#edit-3"></use>
                  </svg>
                </span>
                <span class="map-title-menu-label">{{
                  i18n.t().drawingTools
                }}</span>
                @if (drawingToolsVisible) {
                  <span class="map-title-menu-check" aria-hidden="true">
                    <svg
                      class="sa-icon sa-nofill"
                      viewBox="0 0 24 24"
                      focusable="false"
                      aria-hidden="true"
                    >
                      <use href="/assets/icons/sprite.svg#check"></use>
                    </svg>
                  </span>
                }
              </button>
            }
            <div
              class="map-title-menu-divider dropdown-divider my-1"
              role="separator"
            ></div>
            <button
              class="map-title-menu-item dropdown-item d-flex align-items-center gap-2"
              [class.is-limit-disabled]="mindMapExportBlocked"
              type="button"
              role="menuitem"
              [attr.aria-disabled]="mindMapExportBlocked ? 'true' : null"
              data-testid="mindmap-editor-action-download"
              (click)="onMenuItemClick('download')"
            >
              <span class="map-title-menu-icon" aria-hidden="true">
                <svg
                  class="sa-icon sa-nofill"
                  viewBox="0 0 24 24"
                  focusable="false"
                  aria-hidden="true"
                >
                  <use href="/assets/icons/sprite.svg#download"></use>
                </svg>
              </span>
              <span class="map-title-menu-label">{{ i18n.t().download }}</span>
            </button>
            <button
              class="map-title-menu-item dropdown-item d-flex align-items-center gap-2"
              type="button"
              role="menuitem"
              data-testid="mindmap-editor-action-help"
              (click)="onMenuItemClick('help')"
            >
              <span class="map-title-menu-icon" aria-hidden="true">
                <svg
                  class="sa-icon sa-nofill"
                  viewBox="0 0 24 24"
                  focusable="false"
                  aria-hidden="true"
                >
                  <use href="/assets/icons/sprite.svg#help-circle"></use>
                </svg>
              </span>
              <span class="map-title-menu-label">{{ i18n.t().help }}</span>
            </button>
            <div
              class="map-title-menu-divider dropdown-divider my-1"
              role="separator"
            ></div>
            @if (canDeleteMindMap) {
              <button
                class="map-title-menu-item is-danger text-danger dropdown-item d-flex align-items-center gap-2"
                data-testid="mindmap-editor-action-delete"
                type="button"
                role="menuitem"
                (click)="onMenuItemClick('move-trash')"
              >
                <span class="map-title-menu-icon" aria-hidden="true">
                  <svg
                    class="sa-icon sa-nofill"
                    viewBox="0 0 24 24"
                    focusable="false"
                    aria-hidden="true"
                  >
                    <use href="/assets/icons/sprite.svg#trash-2"></use>
                  </svg>
                </span>
                <span class="map-title-menu-label">{{
                  i18n.t().moveToTrash
                }}</span>
              </button>
            }
          </div>
        }

        @if (!publicViewer && canUpdateMindMap && showVersionsList()) {
          <div
            #versionsPanel
            class="versions-list-panel dropdown-menu show shadow-3"
            role="dialog"
            [attr.aria-label]="i18n.t().versionsPanelAria"
            (click)="onVersionsPanelClick($event)"
          >
            <div class="versions-list-header d-flex align-items-center gap-2">
              <button
                class="versions-list-back btn btn-default btn-icon btn-sm rounded-circle"
                data-testid="mindmap-versions-back"
                type="button"
                [attr.aria-label]="i18n.t().backToMenu"
                (click)="onVersionsBackClick()"
              >
                <svg
                  class="sa-icon sa-nofill"
                  viewBox="0 0 24 24"
                  focusable="false"
                  aria-hidden="true"
                >
                  <use href="/assets/icons/sprite.svg#arrow-left"></use>
                </svg>
              </button>
              <span class="versions-list-title fs-xl fw-600 flex-grow-1">{{
                i18n.t().versions
              }}</span>
              <button
                class="versions-list-close btn btn-default btn-icon btn-sm rounded-circle"
                data-testid="mindmap-versions-close"
                type="button"
                [attr.aria-label]="i18n.t().closeVersionsPanel"
                (click)="closeVersionsPanel()"
              >
                <svg
                  class="sa-icon sa-nofill"
                  viewBox="0 0 24 24"
                  focusable="false"
                  aria-hidden="true"
                >
                  <use href="/assets/icons/sprite.svg#x"></use>
                </svg>
              </button>
            </div>

            <div
              class="versions-list-body"
              (scroll)="closeVersionOptionsMenu()"
            >
              @if (loadingVersions()) {
                <div class="versions-list-loading text-muted small">
                  {{ i18n.t().loadingVersions }}
                </div>
              } @else if (errorVersions()) {
                <div class="versions-list-error text-muted small">
                  {{ errorVersions() }}
                </div>
              } @else if (!groupedVersions().length) {
                <div class="versions-list-empty text-muted small">
                  {{ i18n.t().noVersionsFound }}
                </div>
              } @else {
                <div class="versions-list-groups d-flex flex-column gap-3">
                  @for (group of groupedVersions(); track group.date) {
                    <div class="versions-list-group">
                      <div
                        class="versions-list-group-head d-flex align-items-center justify-content-between"
                      >
                        <span
                          class="versions-list-group-date fs-md fw-600 text-muted"
                          >{{ formatGroupDate(group.date) }}</span
                        >
                      </div>
                      <div class="versions-list-items d-flex flex-column">
                        @for (version of group.versions; track version.id) {
                          <div
                            class="versions-list-item"
                            data-testid="mindmap-version-row"
                            [class.is-active]="
                              selectedVersionId() === version.id
                            "
                            [class.is-options-open]="
                              versionOptionsOpenId() === version.id
                            "
                            (click)="onVersionRowClick(version)"
                          >
                            <div
                              class="versions-list-timeline"
                              aria-hidden="true"
                            >
                              <span class="versions-list-dot"></span>
                              <span class="versions-list-line"></span>
                            </div>

                            <div class="versions-list-item-main">
                              <span class="versions-list-time fs-md fw-500">{{
                                version.createdAt | date: "h:mm a"
                              }}</span>
                              <span
                                class="versions-list-item-title fs-lg fw-500"
                                >{{ getVersionAuthor(version) }}</span
                              >
                            </div>

                            <button
                              class="versions-list-more btn btn-default btn-icon btn-xs rounded-circle"
                              data-testid="mindmap-version-more"
                              type="button"
                              [attr.aria-label]="i18n.t().moreOptions"
                              aria-haspopup="menu"
                              [attr.aria-expanded]="
                                versionOptionsOpenId() === version.id
                              "
                              (click)="
                                onVersionMoreOptionsClick($event, version.id)
                              "
                            >
                              <svg
                                class="sa-icon sa-nofill"
                                viewBox="0 0 24 24"
                                focusable="false"
                                aria-hidden="true"
                              >
                                <use
                                  href="/assets/icons/sprite.svg#more-horizontal"
                                ></use>
                              </svg>
                            </button>
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
            </div>

            @if (versionWithOptionsOpen(); as version) {
              <div
                class="versions-list-more-menu dropdown-menu show"
                role="menu"
                [style.top.px]="versionOptionsMenuPosition()?.top"
                [style.left.px]="versionOptionsMenuPosition()?.left"
                (click)="onVersionMenuClick($event)"
              >
                @if (canUpdateMindMap) {
                  <button
                    type="button"
                    class="versions-list-more-menu-item dropdown-item fs-md"
                    data-testid="mindmap-version-restore"
                    role="menuitem"
                    (click)="onVersionMenuAction('restore', version, $event)"
                  >
                    {{ i18n.t().restoreVersion }}
                  </button>
                }
                @if (canCreateMindMap) {
                  <button
                    type="button"
                    class="versions-list-more-menu-item dropdown-item fs-md"
                    data-testid="mindmap-version-copy"
                    role="menuitem"
                    (click)="onVersionMenuAction('copy', version, $event)"
                  >
                    {{ i18n.t().makeCopy }}
                  </button>
                }
              </div>
            }
          </div>
        }
      </div>

      @if (panelApi.findOpen()) {
        <div
          class="map-title-find-panel pt-1"
          role="dialog"
          [attr.aria-label]="i18n.t().findInMap"
        >
          <div class="find-body" [class.has-query]="panelApi.hasFindQuery()">
            @if (panelApi.hasFindQuery()) {
              @if (!panelApi.findResults().length) {
                <p class="find-empty text-muted small mb-0">
                  {{ i18n.t().noResultsFound }}
                </p>
              } @else {
                <div
                  class="find-results d-flex flex-column gap-1 overflow-auto"
                >
                  @for (
                    result of panelApi.findResults();
                    track result.id;
                    let i = $index
                  ) {
                    <button
                      type="button"
                      class="find-result w-100 text-start"
                      [class.is-active]="i === panelApi.findActiveIndex()"
                      (click)="panelApi.onFindResultClick(result, i)"
                    >
                      <span class="find-result-text">
                        <span class="find-result-title fw-600">{{
                          result.title
                        }}</span>
                        @if (result.snippet) {
                          <span class="find-result-snippet text-muted">{{
                            result.snippet
                          }}</span>
                        }
                      </span>
                    </button>
                  }
                </div>
              }
            }
          </div>

          <div class="find-footer small text-muted">
            {{ i18n.t().findFooterHint }}
          </div>
        </div>
      }
    </div>

    @if (!publicViewer && showVersionsList()) {
      <div class="map-title-menu-backdrop" aria-hidden="true"></div>
    }

    @if (!publicViewer && panelApi.mapMenuOpen()) {
      <div
        class="map-title-menu-backdrop"
        aria-hidden="true"
        (click)="panelApi.onMapMenuClose()"
      ></div>
    }
  }
}
